// extracted by mini-css-extract-plugin
module.exports = {"heading":"Formulario_heading__2Uh5B","buscador":"Formulario_buscador__2yER3","btn-block":"Formulario_btn-block__3rlJs"};